module.exports = __webpack_public_path__ + "static/media/icon_email-to-journal.8e1a2f09.svg";